"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const tvContents: ReactNode = (
  <>
    <section className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Sewa TV Terdekat: Layanan Kilat, Tampilan Maksimal</h2>
      <p className="text-base mb-6">
        Bayangkan ini: kamu lagi nyiapin event, ruang udah rapih, rundown udah fix... tapi layar besar buat tampilan visualnya belum ada. Mau beli? Gak efisien. Solusinya? <strong className="text-red-600">Sewa TV terdekat</strong>. Gak
        ribet. Gak mahal. Gak pake nunggu.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <article className="bg-white border shadow rounded-2xl p-6">
          <h2 className="font-semibold text-lg mb-2">Ready TV 43" Sampai 85" 4K</h2>
          <p className="text-sm">
            Mau ukuran layar sesuai kebutuhanmu? Mulai dari <strong>TV 43 inch</strong> buat booth pameran kecil, sampai <strong>TV 85 inch</strong> untuk ruang ballroom luas semua tersedia, semua <strong>smart TV Android</strong>.
          </p>
        </article>
        <article className="bg-white border shadow rounded-2xl p-6">
          <h2 className="font-semibold text-lg mb-2">Free Ongkir & Instalasi Cepat</h2>
          <p className="text-sm">Tim kami langsung kirim, langsung pasang. Gak cuma antar, tapi disetting dan dites sampai gambar tajam sempurna. Lokasi kamu di hotel, sekolah, kantor, atau mall? Semua bisa.</p>
        </article>
        <article className="bg-white border shadow rounded-2xl p-6">
          <h2 className="font-semibold text-lg mb-2">Cocok Buat Segala Acara</h2>
          <p className="text-sm">Dari seminar, pameran, konser, nobar, sampai live streaming <strong>layar TV untuk acara</strong> bikin atmosfer makin hidup. Audiens fokus, brand kamu terlihat premium.</p>
        </article>
        <article className="bg-white border shadow rounded-2xl p-6">
          <h2 className="font-semibold text-lg mb-2">Harga Sewa TV Terdekat Hemat Budget</h2>
          <p className="text-sm">Mulai <strong>Rp200 ribuan</strong> per hari. Tersedia paket sewa harian, mingguan, hingga langganan bulanan. <strong>Harga sewa TV</strong> menyesuaikan durasi dan jumlah unit.</p>
        </article>
      </div>
      <h2 className="text-xl font-bold mt-10">Kenapa Harus Sewa TV Terdekat Dibanding Beli?</h2>
      <ul className="list-disc pl-5 text-sm space-y-2 mb-4">
        <li>Gak perlu keluarin dana besar untuk <strong>TV event</strong> yang hanya dipakai sesekali.</li>
        <li>Gak repot urusan logistik, setting, dan troubleshooting di lokasi.</li>
        <li>Bisa pilih brand: Samsung, LG, Coocaa, Xiaomi Android TV tinggal pilih.</li>
        <li>Langsung nyala. Langsung bisa dipakai presentasi, YouTube, Zoom, atau media player USB.</li>
      </ul>
      <h2 className="text-xl font-bold mt-10">Layanan Unggulan: TV Nyala, Acara Lancar</h2>
      <p className="text-sm mb-2">
        Di lokasi acara, kami gak cuma kirim lalu pergi. Tim kami pasang, tes koneksi HDMI dan Wi-Fi, bantu setup input sesuai device kamu. Kalau <strong>TV error di tengah acara</strong>? Kami standby. Unit cadangan langsung dikirim. Tanpa
        drama.
      </p>
      <div className="bg-yellow-50 p-4 rounded-xl text-sm">⚠ Note: Semua unit kami dicek rutin. Brightness tinggi, resolusi Full HD & 4K. Karena kami tahu: <strong>satu visual yang gagal bisa rusak seluruh presentasi</strong>.</div>
      <h2 className="text-xl font-bold mt-10">Sewa TV Terdekat = Bebas Stress + Lebih Fleksibel</h2>
      <p className="text-base">Lagi nyari solusi instan tanpa pusing teknis? <strong>Sewa TV terdekat</strong> jadi jawaban. Hemat waktu, hemat logistik, hasil profesional. Bisa langsung tayangin video, presentasi, atau promo produk kamu.</p>
      <p className="text-base mt-4">Gak perlu cari jauh-jauh. <strong>Sewa TV terdekat</strong> sekarang juga. Booking hari ini, tampil maksimal besok!</p>
    </section>

    <CTA
      title="Siap Jadi Smart Pake TV Bosku?"
      description="🚚 Butuh sewa TV terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking TV Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20TV.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Smart TV"
    />

  </>
);
